<template>

<fragment>

    <component 
        :is="viewComponent" 
        :fields="fields"
        :data="data"
        :can="can"
        :filter="filter"
        :view="view"
        :key="$currentView.id"
    >

        <core-content-scrollload 
            v-on:scrolled="$emit('scroll')" 
            v-if="hasMore"
        />

    </component>

</fragment>

</template>

<script>

import $field from '@/field'
import $filter from '@/filter'

export default {

	props: ['data', 'filter', 'view', 'can', 'hasMore'],

    computed: {

        viewComponent: function() {

            var component = ['app', 'view']

            if (this.currentView.type === 1) component.push('list')
            if (this.currentView.type === 2) component.push('sheet')
            if (this.currentView.type === 3) component.push('grid')
            if (this.currentView.type === 4) component.push('gallery')

            return component.join('-')

        },

        currentView: function() {

            return this.$currentView

        },

        fields: function() {

            var fields = []

            var handler = function(field) {

                var type = $field.type[field.type]

                var pass = true

                if (field.devices === 1) {

                    if (!this.window.is.desktop) pass = false

                } else if (field.devices === 2) {

                    if (!this.window.is.mobile) pass = false

                }

                if (type.visibility) {

                    if(!type.visibility.call(this)) pass = false

                }

                if (type.types) {

                    if(!this.$_.contains(type.types, this.$currentContextType)) pass = false

                }

                var onlyFailedSorts = false

                if (field.sorts.length) {

                    var sorts = this.$util.sorts(this.$store.getters['filter/' + this.filter])

                    if(!this.$_.intersection(sorts, field.sorts).length) {

                        if(pass) onlyFailedSorts = true
                        
                        pass = false

                    }

                }

                if (field.filters.length) {

                    var legacyRules = []
                    var advancedRules = []

                    this.$_.each(field.filters, function(id) {

                        var filter = $filter.type[id]

                        advancedRules.push(id)

                        filter.rules = filter.rules || {}

                        this.$_.each(filter.rules.linked || [], function(linked) {

                            advancedRules.push(linked)

                        })

                        this.$_.each(filter.rules.legacy || [], function(legacy) {

                            legacyRules.push(legacy)

                        })

                    }.bind(this))

                    if(!this.$_.intersection(advancedRules, this.$store.getters['filter/' + this.filter + '/advancedKeys']).length && !this.$_.intersection(legacyRules, this.$store.getters['filter/' + this.filter + '/activeKeys']).length) {

                        pass = false

                    } else {

                        if (onlyFailedSorts) pass = true

                    }

                }

                return pass

            }.bind(this)

            var typesAdded = []
            var sortsCovered = []

            this.$_.each(this.currentView.fields, function(field) {

                typesAdded.push(field.type) 

                if($field.type[field.type].sort) sortsCovered.push($field.type[field.type].sort)

            })

            this.$_.each(this.currentView.fields, function(field) {

                if (field.type === 'dynamic.placeholder') {

                    var advancedFilters = this.$store.getters['filter/' + this.filter + '/advancedKeys']
                    var standardFilters = this.$store.getters['filter/' + this.filter + '/activeKeys']
                    var standardSorts = this.$util.sorts(this.$store.getters['filter/' + this.filter])

                    if(field.sorts.length) {

                        standardSorts = this.$_.intersection(standardSorts, field.sorts)

                    } 

                    if(standardSorts.length) {

                        this.$_.each($filter.types, function(filter) {

                            var rules = filter.rules || {}

                            if(this.$_.intersection(standardFilters, rules.legacy || []).length) {

                                advancedFilters.push(filter.key)

                                this.$_.each(rules.linked || [], function(linked) {

                                    advancedFilters.push(linked)

                                })

                            }

                        }.bind(this))

                    }

                    if(field.filters.length) {

                        advancedFilters = this.$_.intersection(advancedFilters, field.filters)

                    }

                    if(advancedFilters.length || standardFilters.length || standardSorts.length) {

                        this.$_.each($field.types, function(type) {

                            if(!this.$_.contains(typesAdded, type.key)) {

                                if(
                                    (
                                        this.$_.contains(standardSorts, type.sort || '')
                                        &&
                                        !this.$_.contains(sortsCovered, type.sort)
                                    )
                                    ||
                                    this.$_.intersection(advancedFilters, type.filters || {}).length
                                ) {

                                    fields.push({
                                        id: 'dynamic/' + field.id + '/' + type.key,
                                        type: type.key,
                                        label: type.default.label || '',
                                        locked: 0,
                                        width: 'default',
                                        customwidth: 0,
                                        sticky: 0,
                                        devices: 0,
                                        sorts: [],
                                        filters: []
                                    })

                                    typesAdded.push(type.key)

                                }

                            }

                        }.bind(this))

                    }

                } else {

                    var pass = handler(field)

                    if (pass) {
                        
                        fields.push(field)

                    }

                }

            }.bind(this))

            return fields

        }

    }

}

</script>

<style scoped>

</style>